// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BzQ5hfmYChX_stMwJT5k {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100vw;
  height: auto;
  margin-top: 2vh;
}


.Eo5uIuOQrtEXAhPdAvgb {
  flex: 1;
  display: block;
  position: absolute; /* to have overlays */
  width: 92vw;
  height: 66vh;
  top: 2vh;
  left: 4vw;
  max-width: 600px;
}

.EUJYDgGTkl363dCpbz_9 {
  display: flex;
  width: 92vw;
  max-width: 600px;
}

.mcfJYp9qFJiOD_LpxUJ1 {
  display: block;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.MCfPwIInfcaLg6wctD8F {
  display: flex;
  flex-direction: column;
  transition: transform 1s ease-in-out;
  width: 50%;
  height: 100%;
  border-radius: 5%;
}

.UrJf4S3Ojuf8LGDqChMn {
  display: flex;
  width: 200%;
  height: 100%;
}

.qgyDAfi0XQSMMVUIV0Tj{
  display: flex;
  flex: 1;
}

.y9SKEd3la1vCX9B9_jIQ {
  display: flex;
  justify-content: end;
  align-items: center;
}
  
`, "",{"version":3,"sources":["webpack://./src/App.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;;AAGA;EACE,OAAO;EACP,cAAc;EACd,kBAAkB,EAAE,qBAAqB;EACzC,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,OAAO;AACT;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB","sourcesContent":[".header {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  width: 100vw;\n  height: auto;\n  margin-top: 2vh;\n}\n\n\n.main_cont {\n  flex: 1;\n  display: block;\n  position: absolute; /* to have overlays */\n  width: 92vw;\n  height: 66vh;\n  top: 2vh;\n  left: 4vw;\n  max-width: 600px;\n}\n\n.header_cont {\n  display: flex;\n  width: 92vw;\n  max-width: 600px;\n}\n\n.booking_cont {\n  display: block;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.page {\n  display: flex;\n  flex-direction: column;\n  transition: transform 1s ease-in-out;\n  width: 50%;\n  height: 100%;\n  border-radius: 5%;\n}\n\n.booking {\n  display: flex;\n  width: 200%;\n  height: 100%;\n}\n\n.item{\n  display: flex;\n  flex: 1;\n}\n\n.meetingTypeSelector {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n}\n  \n"],"sourceRoot":""}]);
// Exports
export var header = `BzQ5hfmYChX_stMwJT5k`;
export var main_cont = `Eo5uIuOQrtEXAhPdAvgb`;
export var header_cont = `EUJYDgGTkl363dCpbz_9`;
export var booking_cont = `mcfJYp9qFJiOD_LpxUJ1`;
export var page = `MCfPwIInfcaLg6wctD8F`;
export var booking = `UrJf4S3Ojuf8LGDqChMn`;
export var item = `qgyDAfi0XQSMMVUIV0Tj`;
export var meetingTypeSelector = `y9SKEd3la1vCX9B9_jIQ`;
export default ___CSS_LOADER_EXPORT___;
